import _ from 'lodash';
import { DateTime } from 'luxon';
import React from 'react';

import {
  StockPriceLineChartQueryHookResult,
  TimeFrame,
  useStockPriceLineChartQuery
} from 'generated/graphql';



export interface IDataPoint {
  x: string;
  y: number;
  fullDate: DateTime;
}
export interface IData {
  domainTicks: string[];
  points: IDataPoint[];
}

export function useQuery(listedCompanyId: string, timeFrame: TimeFrame) {
  const tuple = useStockPriceLineChartQuery({
    variables: {
      listedCompanyId
    }
  });

  return React.useMemo(
    () => {
      const filteredData = __filterStockPrice(timeFrame, tuple.data);
      const numberOfMonths = Math.abs(__getNumberOfMonths(timeFrame));

      const points = filteredData?.map((pt) => ({
        fullDate: pt.date,
        x: __formatDateForTimeFrame(pt.date, numberOfMonths),
        y: pt.value.toNumber()
      })) ?? [];

      const domainTicks = _.uniqBy(points, (p) => p.x).map((p) => p.x);

      const data: IData = {
        points,
        domainTicks
      };

      return {
        ...tuple,
        data
      };
    },
    [
      timeFrame,
      tuple
    ]
  );
}



function __formatDateForTimeFrame(date: DateTime, numMonths: number) {
  if (numMonths > 36) {
    return date.toFormat('yyyy');
  } else if (numMonths > 12) {
    return date.toFormat('MMM yyyy');
  } else if (numMonths >= 6) {
    return date.toFormat('MMM');
  } else {
    return date.toFormat('MMM-dd');
  }
}



function __filterStockPrice(filter: TimeFrame, data: StockPriceLineChartQueryHookResult['data']) {
  const months = __getNumberOfMonths(filter);

  const filteredData = data?.historicalStockPrice.filter((node) => {
    const isLessThanMonth = node.date.diffNow('months').months <= months;
    return !isLessThanMonth;
  });

  return filteredData;
}



function __getNumberOfMonths(filter: TimeFrame) {
  let months;
  if (filter === 'oneMonth') {
    months = -1;
  } else if (filter === 'threeMonths') {
    months = -3;
  } else if (filter === 'sixMonths') {
    months = -6;
  } else if (filter === 'oneYear') {
    months = -12;
  } else if (filter === 'threeYears') {
    months = -36;
  } else {
    // FIVEYEARS
    months = -60;
  }
  return months;
}

